/** @format */
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React, { FunctionComponent } from 'react';

type ControlGroupSkeletonProps = {
    'data-testid'?: string;
    className?: string;
};

export const ControlGroupSkeleton: FunctionComponent<
    ControlGroupSkeletonProps
> = ({ 'data-testid': dataTestId, ...otherProps }) => (
    <div {...otherProps} data-testid={dataTestId}>
        <Skeleton
            variant={SkeletonVariant.BLOCK}
            data-testid={`${dataTestId}__filters`}
        />
        <Skeleton
            variant={SkeletonVariant.BLOCK}
            data-testid={`${dataTestId}__sort-by`}
        />
    </div>
);
